import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setSelectedFundTickers,
  searchForFunds,
  removeScreendFund,
  removeSearchTicker,
} from '../../../actions';
import SearchTable from './SearchTable';
import TickerSelection from '../TickerSelection/TickerSelection';
import i18n from '../../../i18n.js';
import './FundScreener.css';

function FundScreener() {
  const screenedFunds = useSelector(state => state.params.screenedFunds);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [searchButtonEnabled, setSearchButtonEnabled] = useState(false);

  useEffect(() => {
    dispatch(setSelectedFundTickers(screenedFunds));
  }, [screenedFunds, dispatch]);

  function handleInputChange(newValue) {
    setSearchText(newValue);
    if (newValue.length > 2) {
      setSearchButtonEnabled(true);
    } else {
      setSearchButtonEnabled(false);
    }
  }

  function handleSearch() {
    dispatch(searchForFunds(searchText));
  }

  function handleDeleteTicker(externalID) {
    dispatch(removeScreendFund(externalID));
    dispatch(removeSearchTicker(externalID));
  }

  return (
    <div className={'fundScreener'}>

      {/* Show the detault benchmark text */}
      <div className='row'>
        <div className={'selectCopy col-sm-12'}>
          {i18n.t('screener-select-funds')}
        </div>
        <div className={'defaultBenchmark + col-sm-12'}>{i18n.t('screener-default-benchmark-select')}</div>
      </div>

      {/* Show the search bar */}
      <div className={'searchBox row'}>
        <div className='col-md-10 col-sm-12'>
          <input
            type="search"
            id="fund-search"
            name="fund-search"
            placeholder={i18n.t('search-placeholder')}
            onChange={(event) => handleInputChange(event.target.value)}
            onKeyPress={event => {
              if (event.key === 'Enter' && searchButtonEnabled) {
                handleSearch();
              }
            }}
          />
        </div>
        <div className="col-md-2 col-sm-12 input-overflow-fix">
          <div className={'searchButtons'}>
            <button
              className='button'
              disabled={searchButtonEnabled === false}
              onClick={handleSearch}
            >
              {i18n.t('search')}
            </button>
          </div>
        </div>
      </div>

      {/* Show the Tickers Selected */}
      <TickerSelection />

      {/* Show the Search results table */}
      <SearchTable />

    </div>
  );
}

export default FundScreener;
